import { ClientActingUser } from '@/auth/useSession.js';
import { ShouldRenderPredicate } from '@/routes/_layout/-components/nav-link.js';

export const shouldRenderItem = (
  actingUser: ClientActingUser,
  shouldRender?: ShouldRenderPredicate | ShouldRenderPredicate[],
) => {
  return shouldRender
    ? Array.isArray(shouldRender)
      ? shouldRender.some((fn) => fn(actingUser))
      : shouldRender(actingUser)
    : true;
};
